import React from "react";

import Profile from "../../assets/icons/profile.svg";
import ProfileDark from "../../assets/icons/profile-dark.svg";
import Notes from "../../assets/icons/notes.svg";
import NotesDark from "../../assets/icons/notes-dark.svg";
import Support from "../../assets/icons/support.svg";
import Faq from "../../assets/icons/faq.svg";
import AlertIcon from '../../assets/alert-icon.svg';
import SupportDark from "../../assets/icons/support-dark.svg";
import Settings from "../../assets/icons/settings.svg";
import SettingsDark from "../../assets/icons/settings-dark.svg";
import AddSubs from "../../assets/icons/calendar-plus.svg";
import DelSubs from "../../assets/icons/calendar-minus.svg";
import Modal from '../Modal';
import {RouteComponentProps} from 'react-router-dom';
import {INVITE_ENABLED} from '../../utils/referral';

export interface IMenuText {
    selected?: boolean;
}

export interface IMenuItem extends IMenuText {
    to?: string;
    icon: React.ReactNode;
    darkIcon?: React.ReactNode;
    menu: string;
    auth?: boolean;
    isDarkMode?: boolean;
    isUploaderOnly?: boolean;
    isTesterOnly?: boolean;
    onClick?: () => void;
}

// 먼저 써 보는 계정 (이메일): 시험 중인 메뉴(isTesterOnly)가 이 계정에만 보인다
export const MENU_TESTERS = ["telegony@naver.com"];

export const menuList: IMenuItem[] = [
    {
        to: "/auth/profile",
        icon: <Profile/>,
        darkIcon: <ProfileDark/>,
        menu: "프로필 수정",
    },
    // 내 악보 만들기는 홈 첫 화면 '악보 만들기' 버튼으로 (2026-10-11 사장님: 메뉴에서 뺌)
    // {
    //   to: '/membership',
    //   icon: <Ticket />,
    //   menu: '이용권',
    //   selected: true,
    // },
    {
        to: "/",
        icon: <Notes/>,
        darkIcon: <NotesDark/>,
        menu: "악보등록",
        isUploaderOnly: true,
    },
    // {
    //   to: "/playlist",
    //   icon: <Notes />,
    //   darkIcon: <NotesDark />,
    //   menu: "플레이리스트",
    // },
    {
        to: "/notice",
        icon: <AlertIcon/>,
        darkIcon: <AlertIcon/>,
        menu: "알림"
    },
    {
        to: "/support",
        icon: <Support/>,
        darkIcon: <SupportDark/>,
        menu: "문의/요청사항",
    },
    {
        icon: <AddSubs/>,
        darkIcon: <AddSubs/>,
        menu: "구독 신청",
    },
    {
        icon: <DelSubs/>,
        darkIcon: <DelSubs/>,
        menu: "구독 해지",
    },
    ...(INVITE_ENABLED ? [{
        to: "/invite", // 2026-10-17 사장님: 친구에게 초대 링크 보내기, 친구가 구독하면 쿠폰
        icon: <Support/>,
        darkIcon: <SupportDark/>,
        menu: "친구 초대",
    }] : []),
    {
        to: "/faq", // 2026-10-10: 카페 글 대신 사이트 안 FAQ 페이지 (카페는 페이지 맨 아래 '더 보기')
        icon: <Faq />,
        darkIcon: <Faq />,
        menu: "FAQ",
    },
    {
        to: "/howto", // 2026-10-11: 사용법 영상 (유튜브 재생목록)
        icon: <Faq />,
        darkIcon: <Faq />,
        menu: "사용법",
    },
    {
        to: "/setting",
        icon: <Settings/>,
        darkIcon: <SettingsDark/>,
        menu: "설정",
    },
];
